import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '../../../tools/makeStyles';
import visuallyHidden from '@mui/utils/visuallyHidden';
import classNames from 'classnames';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { setTabIndex } from '../../helpers/accessibility_helper';

const useStyles = makeStyles((theme) => ({
  gridWidth: {
    width: '100%',
  },
  previewTitle: {
    color: '#0F7B85',
    fontSize: theme.spacing(3),
    fontWeight: 'bold',
    height: '50%',
    paddingBottom: 8,
  },
  required: {
    color: 'red',
    paddingLeft: 8,
  },
  desc: {
    padding: theme.spacing(1, 0),
  },
  previewDescription: {
    fontSize: theme.spacing(2),
    color: theme.palette.common.black,
    fontWeight: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
}));

const Header = ({
  title,
  titleRef,
  titleAriaLabel,
  description,
  showDescription,
  isRequired,
  isActive = true,
  translation,
}) => {
  const styles = useStyles();

  const ariaLabel = isRequired ? `${titleAriaLabel} (${translation.required})` : titleAriaLabel;

  return (
    <Grid container>
      <Grid item className={styles.gridWidth}>
        <Grid container ref={titleRef} tabIndex={setTabIndex(isActive)}>
          <Typography variant="h1" className={styles.previewTitle}>
            <span aria-label={ariaLabel}>
              {title}
              {isRequired && (
                <>
                  <span aria-hidden className={styles.required}>
                    *
                  </span>
                  <Box sx={visuallyHidden}>This question is required</Box>
                </>
              )}
            </span>
          </Typography>
        </Grid>
      </Grid>
      <Grid item className={classNames(styles.desc)}>
        {showDescription && (
          <Grid container>
            <Typography tabIndex={setTabIndex(isActive)} className={styles.previewDescription}>
              {description}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  showDescription: PropTypes.bool,
  isRequired: PropTypes.bool,
  isActive: PropTypes.bool,
  translation: PropTypes.object,
};

export default Header;
